import { render, staticRenderFns } from "./ClusterMeta.vue?vue&type=template&id=bdbf864e&scoped=true"
import script from "./ClusterMeta.vue?vue&type=script&lang=js"
export * from "./ClusterMeta.vue?vue&type=script&lang=js"
import style0 from "./ClusterMeta.vue?vue&type=style&index=0&id=bdbf864e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbf864e",
  null
  
)

export default component.exports